/**
 * @file pushConfig.js
 * @desc push相关配置
 * @author ~~
 * @data 2024/07/18
 */


// push笔记是否采用push模版
export function usePushComponent(tpSpurce, source) {
    return tpSpurce === 'push' || source === 'pushnote5';
}

// 标题显示百度地图，同时安卓端去头
export function usePushTitle(source) {
    const pushSource = ['pushnote', 'pushnote3', 'pushnote4', 'pushnote5', 'pushywf'];
    return pushSource.includes(source);
}

// push来源返回首页调起全屏
export function pullUpFullScreen(source) {
    const pushAll = ['pushnote', 'pushnote2', 'pushnote3', 'pushnote4', 'pushnote5', 'poipush', 'app_startup_push_by_city',
        'app_startup_push_by_city_uid', 'test_push', 'push', 'pushpoi', 'pushywf', 'push_feed_rec', 'oppooem',
        'poi_detail_push'];
    return pushAll.includes(source);
}

// 首篇是否需要加笔记的展现埋点
export function addPushFeedBury(source) {
    const pushSource = ['pushnote', 'pushywf', 'pushnote5'];
    return !pushSource.includes(source);
}


